import ViewBase from "./view-base.view";


/**
 * Country Restricted Page
 *
 * This page is displayed if user is enters a 
 * module that's restricted to a certain country.
 *
 * @author Darrus Goh
 */
export default function CountryRestrictedView() {
  ViewBase.call(this);

  return {
    view: () => m('.text-center.pt-5',
      m('.vstack.gap-3',
        this.getText('EM00000813', 'This feature is not available in the selected country'),
        m(m.route.Link, { href: '/home' }, this.getText('LT00001130', 'Go back to home page'))
      )
    )
  };
}
